import { render } from "./launch-bergdorf.vue?vue&type=template&id=62cd461b&scoped=true"
import script from "./launch-bergdorf.vue?vue&type=script&lang=js"
export * from "./launch-bergdorf.vue?vue&type=script&lang=js"

import "./launch-bergdorf.vue?vue&type=style&index=0&id=62cd461b&lang=css"
import "./launch-bergdorf.vue?vue&type=style&index=1&id=62cd461b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd461b"]])

export default __exports__